import { createAction, createErrorAction } from '../../actions/actionCreator';
import { GetCalendarOptions, CalendarData } from '@card/commonlib';
import { ActionsType } from '@card/types';

export enum DashboardActionType {
  FetchSoldAmountsStarted = 'dashboard/fetchSoldAmountsStarted',
  FetchSoldAmountsSuccess = 'dashboard/fetchSoldAmountsSuccess',
  FetchSoldAmountsError = 'dashboard/fetchSoldAmountsError',
  FetchCollectedAmountsStarted = 'dashboard/fetchCollectedAmountsStarted',
  FetchCollectedAmountsSuccess = 'dashboard/fetchCollectedAmountsSuccess',
  FetchCollectedAmountsError = 'dashboard/fetchCollectedAmountsError',
  FetchCollectTodayStarted = 'dashboard/fetchCollectTodayStarted',
  FetchCollectTodaySuccess = 'dashboard/fetchCollectTodaySuccess',
  FetchCollectTodayError = 'dashboard/fetchCollectTodayError',
  FetchCollectTomorrowStarted = 'dashboard/fetchCollectTomorrowStarted',
  FetchCollectTomorrowSuccess = 'dashboard/fetchCollectTomorrowSuccess',
  FetchCollectTomorrowError = 'dashboard/fetchCollectTomorrowError',
  FetchMonthlyChargebacksStarted = 'dashboard/fetchMonthlyChargebacksStarted',
  FetchMonthlyChargebacksSuccess = 'dashboard/fetchMonthlyChargebacksSuccess',
  FetchMonthlyChargebacksError = 'dashboard/fetchMonthlyChargebacksError'
}

export const DashboardActions = {
  fetchSoldAmountsStarted: (params: GetCalendarOptions) =>
    createAction(DashboardActionType.FetchSoldAmountsStarted, params),
  fetchSoldAmountsSuccess: (data: CalendarData) =>
    createAction(DashboardActionType.FetchSoldAmountsSuccess, data),
  fetchSoldAmountsError: (error: Error) =>
    createErrorAction(DashboardActionType.FetchSoldAmountsError, error),
  fetchCollectedAmountsStarted: (params: GetCalendarOptions) =>
    createAction(DashboardActionType.FetchCollectedAmountsStarted, params),
  fetchCollectedAmountsSuccess: (data: CalendarData) =>
    createAction(DashboardActionType.FetchCollectedAmountsSuccess, data),
  fetchCollectedAmountsError: (error: Error) =>
    createErrorAction(DashboardActionType.FetchCollectedAmountsError, error),
  fetchCollectTodayStarted: () => createAction(DashboardActionType.FetchCollectTodayStarted),
  fetchCollectTodaySuccess: (data: number) =>
    createAction(DashboardActionType.FetchCollectTodaySuccess, data),
  fetchCollectTodayError: (error: Error) =>
    createErrorAction(DashboardActionType.FetchCollectTodayError, error),
  fetchCollectTomorrowStarted: () => createAction(DashboardActionType.FetchCollectTomorrowStarted),
  fetchCollectTomorrowSuccess: (data: number) =>
    createAction(DashboardActionType.FetchCollectTomorrowSuccess, data),
  fetchCollectTomorrowError: (error: Error) =>
    createErrorAction(DashboardActionType.FetchCollectTomorrowError, error),
  fetchMonthlyChargebacksStarted: () =>
    createAction(DashboardActionType.FetchMonthlyChargebacksStarted),
  fetchMonthlyChargebacksSuccess: (data: number) =>
    createAction(DashboardActionType.FetchMonthlyChargebacksSuccess, data),
  fetchMonthlyChargebacksError: (error: Error) =>
    createErrorAction(DashboardActionType.FetchMonthlyChargebacksError, error)
};

export type DashboardAction = ActionsType<typeof DashboardActions>;
